module.exports = __webpack_public_path__ + "img/center_reight.a779394f.svg";